/**
 * Hangman Word Banks & Categories
 */

export const WORD_BANKS = {
  animals: {
    name: 'Animals',
    icon: '🦁',
    easy: ['LION', 'BEAR', 'WOLF', 'DEER', 'FROG', 'DUCK', 'CRAB', 'SEAL', 'HAWK'],
    medium: ['DOLPHIN', 'GIRAFFE', 'PENGUIN', 'LEOPARD', 'OCTOPUS', 'CHEETAH', 'KANGAROO'],
    hard: ['CHAMELEON', 'PLATYPUS', 'RHINOCEROS', 'ARMADILLO', 'CROCODILE', 'HIPPOPOTAMUS']
  },
  geography: {
    name: 'World & Cities',
    icon: '🌍',
    easy: ['ROME', 'PARIS', 'TOKYO', 'CAIRO', 'OSLO', 'LIMA', 'BERN', 'SEOUL'],
    medium: ['LONDON', 'MADRID', 'BERLIN', 'SYDNEY', 'VIENNA', 'TORONTO', 'BANGKOK'],
    hard: ['REYKJAVIK', 'STOCKHOLM', 'AMSTERDAM', 'SINGAPORE', 'BUCHAREST', 'MONTEVIDEO']
  },
  tech: {
    name: 'Tech & Gaming',
    icon: '💻',
    easy: ['CODE', 'PIXEL', 'BYTE', 'CHIP', 'ROBOT', 'LASER', 'CLOUD', 'DRONE'],
    medium: ['ARCADE', 'PYTHON', 'BINARY', 'SERVER', 'ROUTER', 'MATRIX', 'AVATAR'],
    hard: ['ALGORITHM', 'CYBERPUNK', 'JAVASCRIPT', 'DATABASE', 'PROCESSOR', 'QUANTUM']
  },
  space: {
    name: 'Cosmos & Space',
    icon: '🚀',
    easy: ['MOON', 'STAR', 'MARS', 'ORBIT', 'COMET', 'SOLAR', 'VENUS'],
    medium: ['SATURN', 'JUPITER', 'NEBULA', 'GALAXY', 'METEOR', 'ROCKET', 'APOLLO'],
    hard: ['SUPERNOVA', 'TELESCOPE', 'ASTRONAUT', 'BLACKHOLE', 'ANDROMEDA', 'ASTEROID']
  }
};

export function getRandomWord(categoryKey = 'animals', difficulty = 'medium') {
  const cat = WORD_BANKS[categoryKey] || WORD_BANKS.animals;
  const list = cat[difficulty] || cat.medium;
  const word = list[Math.floor(Math.random() * list.length)];
  return {
    word: word.toUpperCase(),
    category: cat.name,
    categoryKey
  };
}
